var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95811 2H16.0419C19.3272 2 22 4.67279 22 7.95811V16.0419C22 19.3272 19.3272 22 16.0419 22H7.95811C4.67279 22 2 19.3272 2 16.0419V7.95811C2 4.67279 4.67279 2 7.95811 2ZM16.0418 19.988C18.2212 19.988 19.988 18.2212 19.988 16.0419V7.95807C19.988 5.77868 18.2212 4.01196 16.0418 4.01196H7.95806C5.7787 4.01196 4.01195 5.77868 4.01195 7.95807V16.0419C4.01195 18.2212 5.7787 19.988 7.95806 19.988H16.0418ZM7 12.1636C7 9.31641 9.31641 7 12.1637 7C15.0109 7 17.3273 9.31638 17.3273 12.1636C17.3273 15.0109 15.0109 17.3273 12.1637 17.3273C9.31641 17.3273 7 15.0108 7 12.1636ZM9.00846 12.1636C9.00846 13.9062 10.4211 15.3188 12.1636 15.3188C13.9062 15.3188 15.3188 13.9061 15.3188 12.1636C15.3188 10.421 13.9062 9.00842 12.1636 9.00842C10.4211 9.00842 9.00846 10.421 9.00846 12.1636ZM18.3934 6.85756C18.3934 7.54091 17.8395 8.09488 17.1561 8.09488C16.4728 8.09488 15.9188 7.54091 15.9188 6.85756C15.9188 6.17421 16.4728 5.62024 17.1561 5.62024C17.8395 5.62024 18.3934 6.17421 18.3934 6.85756Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIg);
export default __webpack_public_path__ + "static/media/ic_ig.35e9835b46d1da58e547c73a5c3f17db.svg";
export { ForwardRef as ReactComponent };